import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, Link } from 'gatsby';
import Layout from '../components/Layout';
import { Heading, Text, Box, Button } from '@chakra-ui/core';
import BlogPostListItem from '../components/Blog/BlogPostListItem';

interface TagRouteProps {
  data: {
    allMarkdownRemark: {
      edges: {
        frontmatter: any;
        node: any;
      }[];
      totalCount: number;
    };
    site: {
      siteMetadata: {
        title: string;
      };
    };
  };
  pageContext: {
    tag: string;
  };
}

const TagRoute = ({ data, pageContext }: TagRouteProps) => {
  const posts = data.allMarkdownRemark.edges;
  const postLinks = posts.map((post) => (
    <BlogPostListItem
      title={post.node.frontmatter.title}
      date={post.node.frontmatter.date}
      description={post.node.frontmatter.description}
      tags={post.node.frontmatter.tags}
      slug={post.node.fields.slug}
      staticImage={post.node.frontmatter.featuredimage.childImageSharp.fluid}
    />
  ));
  const tag = pageContext.tag;
  const title = data.site.siteMetadata.title;
  const totalCount = data.allMarkdownRemark.totalCount;

  return (
    <Layout>
      <section>
        <Helmet title={`${tag} | ${title}`} />
        <Box mt={[2, 4, 8, 8]}>
          <div>
            <div>
              <Heading>{tag}</Heading>
              <Text>{`${totalCount} ${
                totalCount === 1 ? 'post' : 'posts'
              }`}</Text>
              <Box mt={[2, 2, 4, 4]}>{postLinks}</Box>
              <Link to='/blog'>
                <Button
                  mt={[2, 2, 4, 4]}
                  leftIcon='arrow-back'
                  variantColor='teal'
                >
                  Back to Blog
                </Button>
              </Link>
            </div>
          </div>
        </Box>
      </section>
    </Layout>
  );
};

export default TagRoute;

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            tags
            templateKey
            date(formatString: "MMMM DD, YYYY")
            featuredpost
            featuredimage {
              childImageSharp {
                fluid(maxWidth: 240, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            description
          }
        }
      }
    }
  }
`;
